export default "__VITE_ASSET__y7Qj27NZ__"